import { useMemo } from 'react';
import { computePeriodMemo } from '@/metrics/engine';
import { comparePeriods } from '@/metrics/compare';
import { evaluateDeviations } from '@/metrics/deviations';
import { useData } from './data';
import { useFilters } from './filters';

/**
 * Beregner valgt periode, referanseperiode, sammenligning og avvik fra grunnlagsdata.
 * Alle skjermer, assistenten, CSV og rapporter bruker dette.
 */
export function useResults() {
  const { dataset, status } = useData();
  const filters = useFilters();
  const { query, refQuery } = filters;

  const results = useMemo(() => {
    if (!dataset) return null;
    const current = computePeriodMemo(dataset, query);
    const reference = computePeriodMemo(dataset, refQuery);
    const comparison = comparePeriods(current, reference);
    const deviations = evaluateDeviations(dataset, current, reference);
    return { current, reference, comparison, deviations };
  }, [dataset, query, refQuery]);

  return { ...filters, dataset, status, ready: status === 'ready' && !!results, ...(results ?? { current: null, reference: null, comparison: null, deviations: [] }) };
}
